import { Component, Injector, OnInit } from '@angular/core';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { BaseProductComponent } from '@product/shared/base-product.component';
import { ProductDetails } from '@product/shared/models/catalog';
import { NzIconService } from 'ng-zorro-antd/icon';
import { catchError, forkJoin, Observable, of, switchMap, tap } from 'rxjs';
import { LeftOutline } from '@ant-design/icons-angular/icons';
@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.less']
})
export class ProductDetailsComponent extends BaseProductComponent implements OnInit {
  url = AppConfigService.settings.baseUrl;
  productDetails: ProductDetails;
  id: number = 0;
  productId: number = 0;
  catalogCode: string = '';
  isLoading: boolean = false;
  catalogName: string = '';
  isAuthorized: boolean = false;
  selectedImage: string | null = null;
  constructor(injector: Injector, private iconService: NzIconService) {

    super(injector);
    this.iconService.addIcon(LeftOutline);
  }

  ngOnInit(): void {
    this.getProductDetails();
    this.isAuthorized = !!localStorage.getItem('token');

  }
  getProductDetails(): void {
  this.subscriptions.push(
    this.route.params.pipe(
      tap(params => {
        this.id = params['id'];
        this.productId = params['productId'];
        this.catalogCode = params['catalogCode'];
        this.catalogName = params['name'];
        this.isLoading = true;
      }),
      switchMap(() =>
        this.productCatalog.getCatalogProductDetails(this.id, this.catalogCode, this.productId).pipe(
          switchMap(productDetails => {
            this.productDetails = productDetails;

         
            const mainImage$ = this.getImageUrlByCode(productDetails.mainImage)

             const attributesImages$ = productDetails.images.map((attr: any) =>
              this.getImageUrlByCode(attr)
            );
            // const attributesImages$ = productDetails.attributes.map((attr:any) =>
            //   this.productCatalog.getMediaProduct({
            //     attribute: attr.productImagesPropertyName,
            //     productId: this.productId
            //   }).pipe(
            //     switchMap(blob => this.productCatalog.convertBlobToBase64(blob))
            //   )
            // );

            return forkJoin([mainImage$, ...attributesImages$]);
          })
        )
      ),
      
      tap(([mainImageBase64, ...attributeImagesBase64]) => {
        this.productDetails.mainImage = mainImageBase64;
      this.productDetails.images = attributeImagesBase64;
this.selectedImage = mainImageBase64; 
        this.isLoading = false;
      }),
      catchError(error => {
        console.error('Error loading product details:', error);
        this.isLoading = false;
        return of(null);
      })
    ).subscribe()
  );
}
getImageUrlByCode(imageCode: string): Observable<string | null> {
  if (!imageCode) {
    return of(null);
  }
  
  return this.mediaService.getMediaByCode(imageCode).pipe(
    catchError(() => of(null)),
    switchMap(blob => {
      if (!blob) {
        return of(null);
      }

      const url = this.productCatalog.createImageUrl(blob);
      return of(url);
    })
  );
}

  isImagePath(value: string): boolean {
    if (!value) return false;

    const lower = value.toLowerCase();
    return lower.endsWith('.png') || lower.endsWith('.jpg') || lower.endsWith('.jpeg') || lower.endsWith('.webp');
  }
  
  transformImagePath(path: string): string {

    
    const encodedPath = encodeURIComponent(path);
    return `${this.url}api/Media/get-media?path=${encodedPath}`;
  }
  selectImage(img: string): void {
    this.selectedImage = img;
  }
   override ngOnDestroy(): void {
     this.productCatalog.revokeAll();
      super.ngOnDestroy();
    }
}





